import axios from 'axios';

const state = {
    cancelTokens: {},
}

const _resetCancelToken = function (name) {
    if (state.cancelTokens[name]) {
        state.cancelTokens[name].cancel('[' + name + '] Cancelled by navigation?')
    }
    state.cancelTokens[name] = axios.CancelToken.source()
    return state.cancelTokens[name].token

}

const getters = {}

const actions = {
    async getAsset({ commit }, assetId) {
        try {
            const response = await axios.get(window.envConfig.API_BASEURL + '/api/asset/' + assetId, { withCredentials: true, cancelToken: _resetCancelToken('getAsset:' + assetId) });
            return response.data.asset
        }
        catch (error) {
            console.log(error)
            return null
        }
    },
    async findAvailableAssets({ commit }, options) {
        try {
            const params = Object.assign({}, options)
            const response = await axios.get(window.envConfig.API_BASEURL + '/api/assets/available', { withCredentials: true, params: params, cancelToken: _resetCancelToken('findAvailableAssets') });
            return response.data
        }
        catch (error) {
            console.log(error)
            return {}
        }
    },
    async getCategories({ commit }, options) {
        try {
            const params = Object.assign({}, options)
            const response = await axios.get(window.envConfig.API_BASEURL + '/api/assets/categories', { withCredentials: true, params: params, cancelToken: _resetCancelToken('getCategories') });
            return response.data.categories
        }
        catch (error) {
            console.log(error)
            return []
        }
    },
    async getFeatures({ commit }, options) {
        try {
            const params = Object.assign({}, options)
            const response = await axios.get(window.envConfig.API_BASEURL + '/api/assets/features', { withCredentials: true, params: params });
            return response.data.features
        }
        catch (error) {
            console.log(error)
            return []
        }
    },
    async getManufacturers({ commit }, options) {
        try {
            const params = Object.assign({}, options)
            delete params.manufacturer
            const response = await axios.get(window.envConfig.API_BASEURL + '/api/assets/manufacturers', { withCredentials: true, params: params, cancelToken: _resetCancelToken('getManufacturers') });
            return response.data.manufacturers
        }
        catch (error) {
            console.log(error)
            return []
        }
    },
    async getLocations({ commit }, options) {
        try {
            const params = Object.assign({}, options)
            delete params.category
            delete params.features
            delete params.location
            delete params['not-location']
            const response = await axios.get(window.envConfig.API_BASEURL + '/api/assets/locations', { withCredentials: true, params: params, cancelToken: _resetCancelToken('getLocations') });
            return response.data.locations
        }
        catch (error) {
            console.log(error)
            return []
        }
    },
};

const mutations = {
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}